export default {
  // layout
  LAYOUT: {
  },
  // page
  PAGE: {
  },
  // component
  COMPONENT: {
  },
  // common
  COMMON: {
  }
}
